import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import ReCAPTCHA from 'react-google-recaptcha';

import Validator from '../../common/Validator';
import api from '../../../api/api'

import sendIcon from "../../../img/ic-send-for-button.png";

import '../../../css/ContactInfusionCenterForm.css';

class ContactInfusionCenterForm extends Component {

    constructor (props){
        super(props)
        this.state = {
            name: false,
            email: false,
            phone: false,
            subject: false,
            message: false,
            captcha: null,
            errors: {}
        }
    }

    onChange = (field, event, value) => {
        this.setState({[field]: value});
    }

    onSend = () =>{
        let valid = true;
        let validator = new Validator();
        let errors = {};
        let validators = [
            {
                validate: validator.validateNonNull,
                keys: ["name", "email", "phone", "subject", "message"],
                message: "Please enter a value"
            },
            {
                validate: validator.validateEmail,
                keys: ["email"],
                message: "Please enter a valid email address"
            }
        ];
        validators.forEach((fieldValidator, index) => {
            fieldValidator.keys.forEach((key, keyIndex) => {
                if (!fieldValidator.validate(this.state[key])) {
                    errors[key] = fieldValidator.message;
                    valid = false;
                }
            })
        });
        this.setState({errors: errors});
        if (valid) {
            api.createContactEmail({...this.state, locationId: this.props.location.key})
            this.props.onClose();
        }
    }

    buildTextField(key, hint, floatingLabel, multiLine) {
        return (
            <TextField
                fullWidth={true}
                hintText={hint}
                floatingLabelText={floatingLabel}
                onChange={this.onChange.bind(null, key)}
                errorText={this.state.errors[key]}
                multiLine={multiLine} />
            );
    }

    onCaptchaChange = (value) => {
        this.setState({captcha: value});
    }

    onClose = () => {
        this.setState({captcha: null});
        if (this.props.animateOut) {
            this.props.animateOut();
        } else {
            this.props.onClose();
        }
    }

    render(){
        const title = <div className="contactInfustionCenterTitle">Contact {this.props.location.name}</div>
        // const closeButton =
        // const sendButton =

        return (
            <div className="location-details-contact-form-container">
                <div className="location-details-contact-title">
                    {title}
                </div>
                <div className="location-details-contact-form-content">
                    <div>
                        {this.buildTextField("name", "John Doe", "Your Name", false)}
                    </div>
                    <div>
                        {this.buildTextField("email", "example@abc.com", "Your Email", false)}
                    </div>
                    <div>
                        {this.buildTextField("phone", "1 (234) 567 8900", "Phone Number", false)}
                    </div>
                    <div>
                        {this.buildTextField("subject", "Interested in a visit...", "Subject", false)}
                    </div>
                    <div>
                        {this.buildTextField("message", "Message here...", "Your Message", true)}
                    </div>
                    <div style={{marginTop: "20px"}}>
                        <ReCAPTCHA
                            ref="recaptcha"
                            sitekey="6LfNdhsUAAAAAHxU9LqOu2w-ZW5UXmF32Wj37UYh"
                            onChange={this.onCaptchaChange}
                        />
                    </div>
                    <div style={{textAlign: "right", marginTop: "20px"}}>
                        <FlatButton label="Cancel" labelStyle={{color: "#aab4ba"}} style={{marginRight: "15px"}} onTouchTap={this.onClose}/>
                        <FlatButton disabled={!this.state.captcha} label="Send" labelStyle={{color: "white"}} backgroundColor="#53c9e8" onTouchTap={this.onSend} icon={<img src={sendIcon} alt="send icon" />} />
                    </div>
                </div>
            </div>
        )

    }

}

export default ContactInfusionCenterForm;



// WEBPACK FOOTER //
// ./src/components/locator/details/ContactInfusionCenterForm.js